import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Input } from '@/design-system'
import {
  authFieldSx,
  ErrorBanner,
  FieldError,
  FieldLabel,
  FieldWrap,
  FormPage,
  FormSub,
  FormTitle,
  FormWrap,
  SwapRow,
} from './__styled'
import { validateEmail, validatePhoneNumber } from '@/utils/helper'

interface FormProps {
  error: string
  loading: boolean
  onSubmit: (user: string) => void
}

export default function ForgotForm1({ error, loading, onSubmit }: FormProps) {
  const [user, setUser] = useState('')
  const [editing, setEditing] = useState(false)

  const formError = useMemo(() => {
    const error: Record<string, string> = {}
    if (!user.length) {
      error.user = 'Email or Phone Number is required'
    } else if (!validateEmail(user) && !validatePhoneNumber(user)) {
      error.user = 'Enter Valid Phone/Email'
    }
    return error
  }, [user])

  const onChangeUser = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUser(e.target.value)
    setEditing(true)
  }

  const onSubmitReset = () => {
    if (!formError.user) onSubmit(user)
  }

  return (
    <FormPage>
      <FormWrap>
        <FormTitle>Forgot your password?</FormTitle>
        <FormSub>Enter your registered email or phone number and we'll help you reset it.</FormSub>

        <FieldWrap>
          <FieldLabel>Email or phone</FieldLabel>
          <Input
            variant='filled'
            sx={authFieldSx}
            value={user}
            placeholder='elena@example.com'
            onChange={onChangeUser}
            name='email'
          />
          {editing && !!formError.user && <FieldError>{formError.user}</FieldError>}
        </FieldWrap>

        {!loading && !!error && (
          <ErrorBanner>
            <FieldError sx={{ mt: 0 }}>{error}</FieldError>
          </ErrorBanner>
        )}

        <Button
          variant='spectrum'
          size='lg'
          fullWidth
          disabled={!!formError.user}
          loading={loading}
          onClick={onSubmitReset}
        >
          Submit →
        </Button>

        <SwapRow>
          Already have an account? <Link to='/login'>Sign in</Link>
        </SwapRow>
      </FormWrap>
    </FormPage>
  )
}
